import { useEffect } from "react";

const { GOOGLE_RECAPTCHA_SITE_KEY } = __CONFIG__;

export const useLoadRecaptcha = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
};
